// extracted by mini-css-extract-plugin
module.exports = {"formSubmitted":"FormSubmitted-module--formSubmitted--3u_K_"};